module.exports = __webpack_public_path__ + "img/shakeys_woodbridge_today_2.2a801a5a.jpg";